export default function DailyMetrics() {
    return <></>;
}
